import { render, staticRenderFns } from "./TahsilatTuruPicker.vue?vue&type=template&id=c928ef1a"
import script from "./TahsilatTuruPicker.vue?vue&type=script&lang=ts"
export * from "./TahsilatTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports